export const RESIDENCE_COUNTRY_QUERY = `query Account {
  account {
    user {
      residenceCountry
    }
  }
}`;
